import { useMemo } from 'react';

import { useAtomValue } from 'jotai';

import { SIGN_UP_POST_FLOW_STEP_TYPES } from 'src/apis/dto/DTOSignUpPostFlowResponse';
import useLogin from 'src/hooks/useLogin';
import useSignupPostFlowQuery from 'src/hooks/useSignupPostFlowQuery';
import { remoteConfigAtom } from 'src/stores/auth/atoms';
import { groupInterestsByCategory } from 'src/utils/interest';

const DEFAULT_INTERESTS_SELECTION_MIN_COUNT = 3;
const DEFAULT_INTERESTS_SELECTION_MAX_COUNT = 30;

const useSignupInterests = () => {
  const { isUserJustSignedUp } = useLogin();
  const { data: signupPostFlowData, isFetching } = useSignupPostFlowQuery({
    enabled: isUserJustSignedUp,
  });
  const remoteConfig = useAtomValue(remoteConfigAtom);
  const interestsSelectionMinCount =
    remoteConfig?.interestsSelectionMinCount ?? DEFAULT_INTERESTS_SELECTION_MIN_COUNT;
  const interestsSelectionMaxCount =
    remoteConfig?.interestsSelectionMaxCount ?? DEFAULT_INTERESTS_SELECTION_MAX_COUNT;

  const result = signupPostFlowData?.data?.result;
  const hasInterestSelectionStep =
    result?.steps?.includes(SIGN_UP_POST_FLOW_STEP_TYPES.INTEREST_SELECTION) ?? false;

  const interestData = result?.interestSelection;

  const categorizedInterests = useMemo(
    () => (interestData ? groupInterestsByCategory(interestData) : []),
    [interestData]
  );

  return {
    hasInterestSelectionStep,
    minCount: interestsSelectionMinCount,
    maxCount: interestsSelectionMaxCount,
    categorizedInterests,
    isFetching,
    isSkipEnabled: interestData?.skipEnabled ?? false,
  };
};

export default useSignupInterests;
